import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IMoneda } from '../interfaces/moneda.interface';

@Injectable({
  providedIn: 'root'
})
export class MonedaService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) {}

  getMonedas(): Observable<{ success: boolean; data: IMoneda[] }> {
    return this.http.get<{ success: boolean; data: IMoneda[] }>(`${this.apiUrl}ABCMoneda/GetABCMonedas`);
  }
} 